import LanguageDetector from 'i18next-browser-languagedetector';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import I18NextChainedBackend from 'i18next-chained-backend';
import resourcesToBackend from 'i18next-resources-to-backend';
import ICU from 'i18next-icu';
import HttpBackend from 'i18next-http-backend';
import { resources } from './translations';
import {
  InternationalizationBackendNameSpace,
  InternationalizationNameSpace,
} from '../models/internationalization-namespace';
import { configApp } from './environment-variables';
import { i18format } from 'core/utils';

type SupportedLngsType = 'en' | 'da' | 'de' | 'fi' | 'fr' | 'it' | 'ja' | 'nl' | 'no' | 'pl' | 'sv';
type NamespaceKey = keyof (typeof resources)[keyof typeof resources];
export const defaultNS = InternationalizationNameSpace.Core;
export const supportedLngs = ['en', 'da', 'de', 'fi', 'fr', 'it', 'ja', 'nl', 'no', 'pl', 'sv'];
i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(ICU)
  .use(I18NextChainedBackend)
  .init({
    detection: {
      order: ['navigator', 'localStorage', 'cookie'],
      caches: ['localStorage', 'cookie'],
    },
    ns: [
      InternationalizationBackendNameSpace.Status,
      InternationalizationBackendNameSpace.ErrorCode,
      InternationalizationBackendNameSpace.IncidentCommunication,
      InternationalizationNameSpace.Auth,
      InternationalizationNameSpace.Core,
      InternationalizationNameSpace.Maintenance,
      InternationalizationNameSpace.Assets,
      InternationalizationNameSpace.Companies,
      InternationalizationNameSpace.Dashboard,
      InternationalizationNameSpace.RoboticMowerCodes,
      InternationalizationNameSpace.Faq,
      InternationalizationNameSpace.CookiePolicy,
      InternationalizationNameSpace.Dealers,
      InternationalizationNameSpace.Changelog,
      InternationalizationNameSpace.ThirdPartySoftware,
    ],
    initAsync: false,
    supportedLngs,
    load: 'languageOnly',
    lng: navigator.language,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    i18nFormat: {
      parseErrorHandler: i18format
    },
    backend: {
      crossDomain: true,
      backends: [
        resourcesToBackend((language: SupportedLngsType, namespace: InternationalizationNameSpace) =>
          resources[language]?.[namespace as NamespaceKey]()
        ),
        HttpBackend,
        HttpBackend,
      ],
      backendOptions: [
        {
          // This will try to load the resources from the backend first, if it fails, it will try to load from the local path
          loadPath: './locales/{{lng}}.json',
        },
        {
          loadPath: `${configApp.commonAssetsUrl}/translations/{{ns}}.{{lng}}.json`,
        },
        {
          loadPath: '/translations/{{ns}}.{{lng}}.json',
        },
      ],
    },
    defaultNS,
  });
